import { Injectable } from '@angular/core';

// other services
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// models
import { Newsfeed } from "../models/newsfeed";
import { NewsfeedKeyword } from "../models/newsfeed-keyword";
import { ApiResponse } from "../models/api-response";

// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class NewsfeedService {

    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(private http: HttpClient) { }

    /**
     * get newsfeeds by event
     *
     * @param eventId
     * @param limit
     * @param offset
     *
     * @return {Observable<any>}
     */
    public getListByEvent(eventId: number, limit?: number, offset?: number, filter?: string, filterKeywords?: NewsfeedKeyword[]): Observable<any> {
        let params = {
            limit: limit || 0,
            offset: offset || 0,
            filter: filter || false,
            filterKeywords: filterKeywords || []
        };

        return this.http.post(environment.api + '/event/' + eventId + '/newsfeed', params);
    }

    /**
     * get newsfeed by id
     *
     * @param newsfeedId
     *
     * @return {Observable<Newsfeed>}
     */
    public getById(newsfeedId: number): Observable<any> {

        let url = environment.api + '/newsfeed/' + newsfeedId;
        if (sessionStorage.getItem('preview_token')) {
            url += '?token=' + sessionStorage.getItem('preview_token');
        }

        return this.http.get(url);
    }

    /**
     * create
     *
     * @param newsfeed
     *
     * @return {Observable<any>}
     */
    public create(newsfeed: Newsfeed): Observable<any> {
        return this.http.post(environment.api + '/newsfeed', newsfeed);
    }

    /**
     * update
     *
     * @param newsfeed
     *
     * @return {Observable<any>}
     */
    public update(newsfeed: Newsfeed): Observable<any> {
        return this.http.put(environment.api + '/newsfeed/' + newsfeed.id, newsfeed);
    }

    /**
     * post comment
     *
     * @param newsfeed
     *
     * @return {Observable<any>}
     */
    public postComment(newsfeed: Newsfeed): Observable<any> {
        // edit
        if (newsfeed.editComment.id) {
            return this.http.post(environment.api + '/newsfeed/' + newsfeed.id + '/comment/' + newsfeed.editComment.id, newsfeed.editComment);
        }
        // create
        else {
            return this.http.post(environment.api + '/newsfeed/' + newsfeed.id + '/comment', newsfeed.editComment);
        }
    }

    /**
     * delete comment
     *
     * @param newsfeed
     * @param id - comment id
     *
     * @return {Observable<any>}
     */
    public deleteComment(newsfeed: Newsfeed, id: number): Observable<any> {
        // edit
        return this.http.delete(environment.api + '/newsfeed/' + newsfeed.id + '/comment/' + id);
    }

    /**
     * toggle like
     *
     * @param newsfeed
     *
     * @return {Observable<any>}
     */
    public toggleLike(newsfeed: Newsfeed): Observable<any> {
        return this.http.post(environment.api + '/newsfeed/' + newsfeed.id + '/toggleLike', {});
    }

    /**
     * destroy by id
     *
     * @param id
     *
     * @return {Observable<any>}
     */
    public delete(id: number): Observable<any> {
        return this.http.delete(environment.api + '/newsfeed/' + id);
    }

    /**
     * create post report
     *
     * @param report
     *
     * @return {Observable<any>}
     */
    public reportPost(report): Observable<any> {
        return this.http.post(environment.api + '/newsfeed/' + report.newsfeed_id + '/report', report);
    }

}
